import React from 'react';
import desallLogo from '../../assets/desall_logo.png';
import styles from './LogoAnimation.module.scss';

const LogoAnimation: React.FC = () => {
  return (
    <div className={`${styles.logoAnimation} align-self-center`}>
      <div className={`${styles.logoContainer}`}>
        <div className={`${styles.logoWrapper}`}>
          <img src={desallLogo} alt="Desall Logo" className={`${styles.grayLogo}`} />
          <div className={`${styles.revealMask}`} />
        </div>
      </div>
    </div>
  );
};

export default LogoAnimation;
